/* eslint-disable react/jsx-no-target-blank */
import { useState } from "react";
import "./contact.scss";

export default function Contact() {
  const [message, setMessage] = useState(false);
  const [emails, setEmails] = useState('');
  const [msg, setMsg] = useState('');



  const handleSubmit = (e) => {
    // e.preventDefault();
    // setMessage(true);
    // setEmails('')
    // setMsg('')
  };
  return (
    <div className="contact" id="contact" onSubmit={handleSubmit}>

      <div className=" contactLeft lefts" >

        <h2 style={{ alignItems: "center", textAlign: "center", fontSize: "2.6rem", margin: "auto" }} className="contactHeaderTop">Contact Me</h2>
        <img src="assets/shake.svg" alt="" />
      </div>
      <div className="right contactRight">
        <h2 className="contactHeaderBottom" style={{ fontSize: "2.6rem", overflow: "hidden" }}>Contact Me</h2>

        <div className="emailContact flex-col">

          <h3> hello.shahanshah@gmail.com</h3>
          <br />
          <h3> +91 8929493961</h3>
        </div>

        {/* <div className="socialMedia flex">
          <a href="https://github.com/hello-snsa" target="_blank" >    <img src="assets/icons/github.png" alt="github" /></a>
          <a href="https://github.com/hello-snsa" target="_blank" > <img src="assets/icons/linkedin.png" alt="linkedin" href="https://www.linkedin.com/in/md-ali-shahanshah/" target="_blank" /></a>
          <a href="https://github.com/hello-snsa" target="_blank" >   <img src="assets/icons/twitter.png" alt="twitter" href="https://twitter.com/MDAliShahanshah" target="_blank" /></a>
        </div> */}


        <form name="contact" method="post" className="contactForm" >

          <input type="hidden" name="form-name" value="contact" />

          <input type="email" placeholder="Email" name="email" value={emails} onChange={(e) => setEmails(e.target.value)} id="emailInput" />

          <textarea placeholder="Message" name="message" value={msg} onChange={(e) => setMsg(e.target.value)} >
          </textarea>
          <div>
            <div data-netlify-recaptcha="true">

            </div>

          </div>
          <button type="submit" id="submitContactBtn">Send</button>
          {message && <span>Thanks for showing interest.I'll reply ASAP </span>}
        </form>

        <div className="socialMedia flex">
          <a href="https://github.com/hello-snsa" target="_blank" >    <img src="assets/icons/github.png" alt="github" /></a>
          <a href="https://www.linkedin.com/in/md-ali-shahanshah/" target="_blank" > <img src="assets/icons/linkedin.png" alt="linkedin" target="_blank" /></a>
          <a href="https://twitter.com/MDAliShahanshah" target="_blank" >   <img src="assets/icons/twitter.png" alt="twitter" target="_blank" /></a>
        </div>



      </div>

    </div>
  );
}
